import React from "react";

import { Box, Grid } from "@mui/material";
import { QueryClient, QueryClientProvider } from "react-query";
import { useAppSelector } from "../../../Config/Hooks";
import { ASectionTitle } from "@atiautomacao/ati-ui-library";

import BatteriesPage from "./batteries/BatteriesPage";


export default function DashboardPowerPlantBatteriesPage() {
    const queryClient = new QueryClient();
    const { selectedPowerPlant } = useAppSelector((state) => state.dashboard);

    return (
        <QueryClientProvider client={queryClient}>
            <Box style={{ paddingBottom: '20px', paddingTop: 0, marginTop: 0, marginLeft: '10px', marginRight: '10px' }}>
                <Grid container>
                    <Grid item xs={12} style={{ marginBottom: 16 }}>
                        <ASectionTitle
                            styleContainer={{ padding: "0 0 8px 0" }}
                            styleContainerTitle={{ padding: "0px" }}
                            styleTitle={{ fontWeight: 700, fontSize: 18 }}
                            titleLabel="Baterias / BESS"
                        />
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: 16 }}>

                        {selectedPowerPlant ? <BatteriesPage powerPlant={selectedPowerPlant} /> : null}

                    </Grid>
                </Grid>
            </Box>
        </QueryClientProvider>
    );
}
